import styles from "./App.module.css";
import Hero from "./Components/Hero Section/Hero";
import MainSection from "./Components/Main Section/MainSection";
import Navbar from "./Components/Navbar/Navbar";
import SidebarRight from "./Components/Side Bar Right/SidebarRight";
import YoutubeEmbed from "./Components/YoutubeEmbed/YoutubeEmbed";
import Footer from "./Components/Footer/Footer";
import MeetTheTeam from "./Components/MeetTheTeam/MeetTheTeam";

import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

function App() {
  return (
    <>
      <Router>
        <Navbar />
        <div className={styles.mainContainer}>
          <Switch>
            <Route exact path="/">
              <div className={styles.row1}>
                <Hero />
              </div>
              <div className={styles.row2}>
                <MainSection />
              </div>
              <YoutubeEmbed />
              <Footer />
            </Route>
            <Route exact path="/aboutus">
              <MeetTheTeam />
            </Route>
          </Switch>
        </div>
      </Router>
    </>
  );
}

export default App;
